import { environment } from "../../environments/environment";
export class AppSettings {
	public static get PRODUCTION(): boolean {
		return environment.production;
	}
	public static get API_ENDPOINT(): string {
		return environment.API_ENDPOINT;
	}
	public static get URL_ENDPOINT(): string {
		return environment.URL_ENDPOINT;
	}
	public static get TIME_OUT(): number {
		return environment.timeout;
	}
	public static get CACHE_REFRESH_INTERVAL():number{
		return environment.cacheRefreshInterval;
	}
	public static get VV_LOGIN_EP(): string {
		return "/api/dashboard/login";
	}
	public static get VV_INVITE_CONFIRM_EP(): string {
		return "/api/dashboard/invite";
	}
	public static get VV_CHANGE_PASSWORD_EP(): string {
		return "/api/dashboard/changepassword";
	}
	public static get VV_SERVER_VERSION_EP(): string {
		return "/api/version";
	}
	public static get VV_FORGOT_PASSWORD_EP(): string {
		return "/api/dashboard/forgotpassword";
	}
	public static get VV_LOGOUT_EP(): string {
		return "/api/dashboard/logout";
	}
	public static get VV_CLIENT_EDIT_EP(): string {
		return "/api/dashboard/client/edit";
	}
	public static get VV_TENANT_EDIT_EP(): string {
		return "/api/dashboard/tenant/edit";
	}
	public static get VV_ENVIRONMENT_EDIT_EP(): string {
		return "/api/dashboard/env/edit";
	}
	public static get VV_FORM_SAVE_EP(): string {
		return "/api/dashboard/form/create";
	}
	public static get VV_FORM_LIST_EP(): string {
		return "/api/dashboard/form/";
	}
	public static get VV_FORM_EDIT_EP(): string {
		return "/api/dashboard/form/edit";
	}
	public static get VV_FORM_PUBLSIH_EP(): string {
		return "/api/form/publish";
	}
	public static get VV_FORM_EXPORT_EP(): string {
		return "/api/dashboard/form/export";
	}
	public static get VV_FORM_IMPORT_EP(): string {
		return "/api/dashboard/form/import";
	}
	public static get VV_DASHBOARD_ALL_EP(): string {
		return "/api/dashboard/all";
	}
	public static get VV_USERS_LIST_EP():string{
		return "/api/dashboard/users";
	}
	public static get VV_USERS_SAVE_EP():string{
		return "/api/dashboard/users";
	}
	public static get VV_USERS_ADD_EP():string{
		return "/api/dashboard/sendinvite";
	}
	public static get VV_GENERATE_CLIENT_SECRET_EP():string{
		return "/api/dashboard/clientsecret";
	}
	public static get VV_STATUS_WITH_DATE_RANGE_EP():string{
		return "/api/dashboard/statuswithrange";
	}
	public static get VV_CONFIG_LOCALE_EP():string{
		return "/api/dashboard/config/";
	}
	public static get VV_GLOBAL_FORMS_LIST_EP():string{
		return "/api/dashboard/globalform/list";
	}
	public static get VV_GLOBAL_FORMS_CREATE_EP():string{
		return "/api/dashboard/globalform/create";
	}
	public static get VV_GLOBAL_FORMS_EDIT_EP():string{
		return "/api/dashboard/globalform/edit";
	}
	public static get VV_GLOBAL_FORMS_PDF_EP():string{
		return "/api/dashboard/globalform";
	}
	public static get VV_GLOBAL_FORM_EXPORT_EP(): string {
		return "/api/dashboard/globalform/export";
	}
	public static get VV_GLOBAL_FORM_IMPORT_EP(): string {
		return "/api/dashboard/globalform/import";
	}
}
